import "./Loader.scss";

export interface ILoadingComponentProps {
  visible: boolean;
}

function LoadingComponent(props: ILoadingComponentProps) {
  if (props.visible) {
    return (
      <div className="loadingComponentBackground">
        {/* <div className="loadingComponentContainer">
        </div> */}
      </div>
    );
  } else {
    return <></>;
  }
}

export default LoadingComponent;
